export default function getGlobalConfig()
{
     return {
         baseUrl: process.env.REACT_APP_API_URL,
         auth: {
             domain: process.env.REACT_APP_AUTH_DOMAIN,
             scope: process.env.REACT_APP_AUTH_SCOPE,
             clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
             audience: process.env.REACT_APP_AUTH_AUDIENCE
         },
        printToken: process.env.REACT_APP_PRINT_TOKEN === 'true'
     }
}